import { UPDATE_DMX_DEVICE_PRESET, UPDATE_DMX_DEVICE_PRESET_SUCCESSFUL, UPDATE_DMX_DEVICE_PRESET_FAILED } from './actionTypes';

const initialState = {
  updateDmxDevicePresetError: null,
  messageDmxDevicePreset: null,
  loadingUpdateDmxDevicePreset: false,
};

const updateDevicePreset = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_DMX_DEVICE_PRESET:
      state = { ...state, loadingUpdateDmxDevicePreset: true, updateDmxDevicePresetError: null };
      break;
    case UPDATE_DMX_DEVICE_PRESET_SUCCESSFUL:
      state = { ...state, loadingUpdateDmxDevicePreset: false, messageDmxDevicePreset: action.payload, updateDmxDevicePresetError: null };
      break;
    case UPDATE_DMX_DEVICE_PRESET_FAILED:
      state = { ...state, messageDmxDevicePreset: null, loadingUpdateDmxDevicePreset: false, updateDmxDevicePresetError: action.payload };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default updateDevicePreset;
